import * as types from './actions.js'

const initialState = {
  tokenId: null,
  isAccountant: false,
  photo: {},
  selectedClient: {},
  err: null,
  isFetching: false,
  clients: null//[]
}

function accountantsReducer(state=initialState, action) {
  switch (action.type) {
    case types.GET_ACCOUNTANT_GROUP_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case types.GET_ACCOUNTANT_GROUP_SUCCESS:
      return {
        ...state,
        isFetching: false,
        clients: action.json.clients && action.json.clients.length>0 ? action.json.clients : null
      }
    case 'MOCK_ACCOUNTANT_WITH_CLIENTS':
      return {
        ...state,
        clients: [{name:'Ann', last:'Smith', email: 'ann@test.com'}, {invited: true, name:'Bob', last:'Smith', email: 'bob@test.com'},
        {name:'Ann', last:'Smith', email: 'ann@test.com'}, {invited: true, name:'Bob', last:'Smith', email: 'bob@test.com'},
        {name:'Ann', last:'Smith', email: 'ann@test.com'}, {invited: true, name:'Bob', last:'Smith', email: 'bob@test.com'}
      ]
      }
    case 'GET_CLIENT_REQUEST':
      return {
        ...state,
        selectedClient: {},
        isFetching: true
      }
    case 'GET_CLIENT_SUCCESS':
      return {
        ...state,
        selectedClient: action.client,
        isFetching: false
      }

    case 'GET_CLIENT_FAIL':
      return {
        ...state,
        selectedClient: {},
        err: action.err,
        isFetching: false
      }


    case types.CREATE_CLIENT_INVITES_SUCCESS:
      return {
        ...state,
        group_as_accountant: {
          ...state.group_as_accountant,
          invited_clients: action.json
        }
      }
    case "CREATE_ACCOUNTANT_GROUP_SUCCESS":
      return {
        ...state,
        isAccountant: true,
        tokenId: action.json.token_id,
      }
    case "USER_SUCCESS":
      const accountantGroupData = action.user.group_as_accountant
      const tokenId = accountantGroupData && accountantGroupData.token_id
      if (!tokenId) return state
      return {
        ...state,
        isAccountant: true,
        tokenId,
        ...accountantGroupData
      }

    default:
      return state
  }
}
export default accountantsReducer

// SELECTORS
// TODO import the validators from enterprise or move to core



// WEBPACK FOOTER //
// ./src/accountants/reducer.js